/**
 * Íconos de línea de eco (16 px, trazo 1,6, esquinas redondeadas). Propios y
 * mínimos: solo los que usa la interfaz. Heredan el color del texto.
 */
import type { ReactNode, SVGProps } from 'react'

type P = SVGProps<SVGSVGElement> & { size?: number }

function Svg({ size = 16, children, ...rest }: P & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  )
}

export const IconLibrary = (p: P) => (
  <Svg {...p}>
    <rect x="2" y="2.5" width="12" height="11" rx="2" />
    <path d="M5 6h6M5 8.5h6M5 11h3.5" />
  </Svg>
)
export const IconTasks = (p: P) => (
  <Svg {...p}>
    <rect x="2.5" y="2.5" width="11" height="11" rx="2.5" />
    <path d="M5.5 8.2l1.7 1.7 3.3-3.6" />
  </Svg>
)
export const IconUpload = (p: P) => (
  <Svg {...p}>
    <path d="M8 10.5V3M5 6l3-3 3 3" />
    <path d="M3 10.5v1.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-1.5" />
  </Svg>
)
export const IconPlan = (p: P) => (
  <Svg {...p}>
    <circle cx="8" cy="8" r="5.5" />
    <path d="M8 5v3l2 1.5" />
  </Svg>
)
export const IconTeam = (p: P) => (
  <Svg {...p}>
    <circle cx="6" cy="6" r="2.2" />
    <path d="M2.2 13c.4-2 2-3.2 3.8-3.2S9.4 11 9.8 13" />
    <circle cx="11" cy="6.5" r="1.8" />
    <path d="M10.6 9.9c1.6.1 2.8 1.2 3.2 3" />
  </Svg>
)
export const IconSettings = (p: P) => (
  <Svg {...p}>
    <path d="M3 4.5h6M12 4.5h1M3 11.5h1M7 11.5h6" />
    <circle cx="10.5" cy="4.5" r="1.5" />
    <circle cx="5.5" cy="11.5" r="1.5" />
  </Svg>
)
export const IconHelp = (p: P) => (
  <Svg {...p}>
    <circle cx="8" cy="8" r="5.5" />
    <path d="M6.4 6.4a1.7 1.7 0 0 1 3.2.6c0 1.2-1.6 1.4-1.6 2.4" />
    <path d="M8 11.3h.01" strokeWidth={2} />
  </Svg>
)
export const IconAdmin = (p: P) => (
  <Svg {...p}>
    <path d="M8 2.5l4.5 1.8v3.4c0 2.8-1.9 4.9-4.5 5.8-2.6-.9-4.5-3-4.5-5.8V4.3z" />
  </Svg>
)
export const IconFolder = (p: P) => (
  <Svg {...p}>
    <path d="M2.5 5a1.5 1.5 0 0 1 1.5-1.5h2.3l1.4 1.5H12a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 12 13H4a1.5 1.5 0 0 1-1.5-1.5z" />
  </Svg>
)
export const IconPlus = (p: P) => (
  <Svg {...p}>
    <path d="M8 3.5v9M3.5 8h9" />
  </Svg>
)
export const IconSearch = (p: P) => (
  <Svg {...p}>
    <circle cx="7" cy="7" r="4.3" />
    <path d="M10.3 10.3L13 13" />
  </Svg>
)
export const IconChevronDown = (p: P) => (
  <Svg {...p}>
    <path d="M4.5 6.5L8 10l3.5-3.5" />
  </Svg>
)
export const IconArrowLeft = (p: P) => (
  <Svg {...p}>
    <path d="M12.5 8h-9M7 4.5L3.5 8 7 11.5" />
  </Svg>
)
export const IconMore = (p: P) => (
  <Svg {...p}>
    <circle cx="3.5" cy="8" r=".6" strokeWidth={1.8} />
    <circle cx="8" cy="8" r=".6" strokeWidth={1.8} />
    <circle cx="12.5" cy="8" r=".6" strokeWidth={1.8} />
  </Svg>
)
export const IconShare = (p: P) => (
  <Svg {...p}>
    <path d="M8 2.8v7.4M5.2 5.4L8 2.6l2.8 2.8" />
    <path d="M4.5 8H4a1.5 1.5 0 0 0-1.5 1.5v2A1.5 1.5 0 0 0 4 13h8a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 12 8h-.5" />
  </Svg>
)
export const IconDownload = (p: P) => (
  <Svg {...p}>
    <path d="M8 2.5V10M5 7l3 3 3-3" />
    <path d="M3 12.5h10" />
  </Svg>
)
export const IconMail = (p: P) => (
  <Svg {...p}>
    <rect x="2" y="3.5" width="12" height="9" rx="1.8" />
    <path d="M2.5 4.5L8 8.8l5.5-4.3" />
  </Svg>
)
export const IconCopy = (p: P) => (
  <Svg {...p}>
    <rect x="5" y="5" width="8.5" height="8.5" rx="1.8" />
    <path d="M3 10.5V4a1.5 1.5 0 0 1 1.5-1.5H11" />
  </Svg>
)
export const IconTrash = (p: P) => (
  <Svg {...p}>
    <path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8a1.5 1.5 0 0 0 1.5 1.4h2.8a1.5 1.5 0 0 0 1.5-1.4l.6-8" />
  </Svg>
)
export const IconAsk = (p: P) => (
  <Svg {...p}>
    <path d="M3 4.5A1.5 1.5 0 0 1 4.5 3h7A1.5 1.5 0 0 1 13 4.5v5A1.5 1.5 0 0 1 11.5 11H7l-3 2.5V11h.5" />
    <path d="M5.5 6h5M5.5 8h3" />
  </Svg>
)
export const IconClose = (p: P) => (
  <Svg {...p}>
    <path d="M4 4l8 8M12 4l-8 8" />
  </Svg>
)
export const IconPlay = (p: P) => (
  <Svg {...p}>
    <path d="M5 3.8v8.4a.6.6 0 0 0 .9.5l6.6-4.2a.6.6 0 0 0 0-1L5.9 3.3a.6.6 0 0 0-.9.5z" />
  </Svg>
)
export const IconPause = (p: P) => (
  <Svg {...p}>
    <path d="M5.5 3.5v9M10.5 3.5v9" />
  </Svg>
)
export const IconThumb = (p: P) => (
  <Svg {...p}>
    <path d="M5 7.2V13H3.3a.8.8 0 0 1-.8-.8V8a.8.8 0 0 1 .8-.8zM5 7.2l2.3-4.1a1.2 1.2 0 0 1 2.2.8L9 6.5h3.1a1.3 1.3 0 0 1 1.3 1.5l-.7 3.9A1.3 1.3 0 0 1 11.4 13H5" />
  </Svg>
)
export const IconPeople = IconTeam
